const changePassStyles = (theme) => {
  return {
    gridOccupy: {
      width: '100%',
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
    },
    inputStyles: {
      height: 25,
      minWidth: 320,
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(3),
      flex: 1,
      paddingLeft: 5,
      '& .MuiFormHelperText-contained': {
        marginLeft: 0,
      },
      '& .MuiFormHelperText-root': {
        marginTop: 0,
      },
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0000003b',
      },
    },
    button: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      color: '#fff', //D1373F
      backgroundColor: '#008000',
      borderColor: '#008000',
      minWidth: theme.spacing(14),
      borderWidth: theme.spacing(0.2),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },
    button1: {
      marginTop: '1rem',
      backgroundColor: '#AD000B',
      marginLeft: '0.5rem',
      marginRight: '0.5rem',
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
      borderRadius: theme.spacing(5),
    },
    btnContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    star: {
      color: 'red',
    },
    customTooltip: {
      // I used the rgba color for the standard "secondary" color
      backgroundColor: 'rgb(93, 173, 226)',
    },
  };
};

export default changePassStyles;
